module.exports = __webpack_public_path__ + "static/youtube-music-57080b0800bbe665a94dd6bebd3be0b8.jpg";